const Versand = 5.9;

const UserFields = [
    ['institution', 'Institution'],
    ['firstname', 'Vorname'],
    ['name', 'Name'],
    ['address', 'Adresse'],
    ['zip', 'PLZ'],
    ['city', 'Ort'],
    ['country', 'Land'],
  ];

const Countries = [
  {value:'CH', text:'Schweiz'},
//  {value:'DE', text:'Deutschland'},
//  {value:'AT', text:'Österreich'},
];
  
const Pens = [
  {value:'-', text:'-'},
  {value:'tiptoi', text:'Tiptoi'},
  {value:'bookii', text:'BOOKii'},
];
  
const PrintModi = 
  ['0111', '0211', '0311', '0412', '1111', '1112', '1113', '1122', '1132', '1133', '1212', '1213', '1222', '1223', '1232', '1233', '1313', '1322', 
  '1323', '1332', '1333', '1412', '1413', '1422', '1423', '1432', '1433', '1513', '1522', '1523', '1532', '1533'];
  
  const voiceoptions = {
    'de-DE': {
      name: 'Deutsch 1 exakt',
      voice: {
        W: { voice: 'C', pitch: 1 },
        M: { voice: 'E', pitch: 1 },
        G: { voice: 'F', pitch: 4.4},
        B: { voice: 'B', pitch: 6},
      }
    },
    'de-DE-live': {
      name: 'Deutsch 2 lebendig',
      voice: {
        W: { voice: 'C', pitch: 1 },
        M: { voice: 'E', pitch: 1 },
        G: { voice: 'F', pitch: 4.4},
        B: { voice: 'B', pitch: 6},
      }
    },
    'en-GB': {
      name: 'Englisch',
      voice: {
        W: { voice: 'C', pitch: 1 },
        M: { voice: 'B', pitch: 1 },
        G: { voice: 'A', pitch: 3.2},
        B: { voice: 'D', pitch: 7.2},
      }
    },
    'fr-FR': {
      name: 'Französisch',
      voice: {
        W: { voice: 'A', pitch: 1 },
        M: { voice: 'D', pitch: 1 },
        G: { voice: 'E', pitch: 4.8},
        B: { voice: 'B', pitch: 5.6},
      }
    },
    'it-IT': {
      name: 'Italienisch',
      voice: {
        W: { voice: 'A', pitch: 1 },
        M: { voice: 'D', pitch: 1.2 },
        G: { voice: 'B', pitch: 2.4},
        B: { voice: 'C', pitch: 5.6},
      }
    },
    'sq-SQ': {
      name: 'Albanisch',
      voice: {
        W: { voice: 'A', pitch: 1 },
      }
    },
    'pt-PT': {
      name: 'Portugiesisch',
      voice: {
        W: { voice: 'D', pitch: 1 },
        M: { voice: 'B', pitch: 1.2 },
        G: { voice: 'D', pitch: 2.4},
        B: { voice: 'B', pitch: 5.6},
      }
    },
    'es-ES': {
      name: 'Spanisch',
      voice: {
        W: { voice: 'F', pitch: 1 },
        M: { voice: 'G', pitch: 1.2 },
        G: { voice: 'F', pitch: 2.4},
        B: { voice: 'G', pitch: 5.6},
      }
    },
    'tr-TR': {
      name: 'Türkisch',
      voice: {
        W: { voice: 'D', pitch: 1 },
        M: { voice: 'E', pitch: 1.2 },
        G: { voice: 'D', pitch: 2.4},
        B: { voice: 'E', pitch: 5.6},
      }
    },
    'sr-RS': {
      name: 'Serbisch',
      voice: {
        W: { voice: 'A', pitch: 1 },
        G: { voice: 'A', pitch: 2.4},
      }
    },
    'uk-UA': {
      name: 'Ukrainisch',
      voice: {
        W: { voice: 'A', pitch: 1 },
      }
    },
    'ch-AG': {
      name: 'Aargauerdeutsch',
      voice: {
        W: { voice: 'Aargau', eleven: 'zZ83y5lEtxy7uhDLVscS'},
        M: { voice: 'Aargau', eleven: 're2r5d74PqDzicySNW0I'},
        G: { voice: 'Aargau', eleven: 'LB5G0Z4EP98YaEgL654m'},
        B: { voice: 'Aargau', eleven: '7bAxGs7snwywohl5VytO'},
      }
    },
    'ch-BS': {
      name: 'Baslerdeutsch',
      voice: {
        W: { voice: 'Basel', eleven: 'zZ83y5lEtxy7uhDLVscS'},
        M: { voice: 'Basel', eleven: 're2r5d74PqDzicySNW0I'},
        G: { voice: 'Basel', eleven: 'LB5G0Z4EP98YaEgL654m'},
        B: { voice: 'Basel', eleven: '7bAxGs7snwywohl5VytO'},
      }
    },
    'ch-BE': {
      name: 'Berndeutsch',
      voice: {
        W: { voice: 'Bern', eleven: 'zZ83y5lEtxy7uhDLVscS'},
        M: { voice: 'Bern', eleven: 're2r5d74PqDzicySNW0I'},
        G: { voice: 'Bern', eleven: 'LB5G0Z4EP98YaEgL654m'},
        B: { voice: 'Bern', eleven: '7bAxGs7snwywohl5VytO'},
      }
    },
    'ch-GR': {
      name: 'Bündnerdeutsch',
      voice: {
        W: { voice: 'Graubünden', eleven: 'zZ83y5lEtxy7uhDLVscS'},
        M: { voice: 'Graubünden', eleven: 're2r5d74PqDzicySNW0I'},
        G: { voice: 'Graubünden', eleven: 'LB5G0Z4EP98YaEgL654m'},
        B: { voice: 'Graubünden', eleven: '7bAxGs7snwywohl5VytO'},
      }
    },
    'ch-LU': {
      name: 'Luzernerdeutsch',
      voice: {
        W: { voice: 'Luzern', eleven: 'zZ83y5lEtxy7uhDLVscS'},
        M: { voice: 'Luzern', eleven: 're2r5d74PqDzicySNW0I'},
        G: { voice: 'Luzern', eleven: 'LB5G0Z4EP98YaEgL654m'},
        B: { voice: 'Luzern', eleven: '7bAxGs7snwywohl5VytO'},
      }
    },
    'ch-SG': {
      name: 'St. Gallerdeutsch',
      voice: {
        W: { voice: 'St. Gallen', eleven: 'zZ83y5lEtxy7uhDLVscS'},
        M: { voice: 'St. Gallen', eleven: 're2r5d74PqDzicySNW0I'},
        G: { voice: 'St. Gallen', eleven: 'LB5G0Z4EP98YaEgL654m'},
        B: { voice: 'St. Gallen', eleven: '7bAxGs7snwywohl5VytO'},
      }
    },
    'ch-VS': {
      name: 'Walliserdeutsch',
      voice: {
        W: { voice: 'Wallis', eleven: 'zZ83y5lEtxy7uhDLVscS'},        
        M: { voice: 'Wallis', eleven: 're2r5d74PqDzicySNW0I'},
        G: { voice: 'Wallis', eleven: 'LB5G0Z4EP98YaEgL654m'},        
        B: { voice: 'Wallis', eleven: '7bAxGs7snwywohl5VytO'},
      }
    },
    'ch-ZH': {
      name: 'Zürcherdeutsch',
      voice: {
        W: { voice: 'Zürich', eleven: 'zZ83y5lEtxy7uhDLVscS'},
        M: { voice: 'Zürich', eleven: 're2r5d74PqDzicySNW0I'},
        G: { voice: 'Zürich', eleven: 'LB5G0Z4EP98YaEgL654m'},
        B: { voice: 'Zürich', eleven: '7bAxGs7snwywohl5VytO'},
      },
    },
  }
  
  const channelIcons = [ 'circle','square','triangle','suit-diamond','x-lg','star'];  

  const sizesSticker = [
    {value:'20', text:'Standard rund 20mm'},
    {value:'40', text:'Mittel quadratisch 40mm'},
    {value:'60', text:'Gross quadratisch 60mm'},
  ];
  const sizesImg = [
    {value: '6x9', text: 'Hochformat 6 x 9 (2.8 cm)'},
    {value: '5x8', text: 'Hochformat 5 x 8 (3.2 cm)'},
    {value: '4x6', text: 'Hochformat 4 x 6 (4.4 cm)'},
    {value: '3x4', text: 'Hochformat 3 x 4 (6.3 cm)'},
    {value: '2x3', text: 'Hochformat 2 x 3 (8.9 cm)'},
    {value: '1x2', text: 'Hochformat 1 x 2 (13.5 cm)'},
    {value: '9x6', text: 'Querformat 9 x 6 (2.9 cm)'},
    {value: '8x5', text: 'Querformat 8 x 5 (3.3 cm)'},
    {value: '6x4', text: 'Querformat 6 x 4 (4.5 cm)'},
    {value: '4x3', text: 'Querformat 4 x 3 (6.0 cm)'},
    {value: '3x2', text: 'Querformat 3 x 2 (9.1 cm)'},
    {value: '2x1', text: 'Querformat 2 x 1 (14.0 cm)'},
    {value: '8x11', text: 'Etiketten 8 x 11 (2 cm)'},
    {value: '5x7', text: 'Etiketten 5 x 7 (3.5 cm)'},
  ];

export { UserFields, Countries, Pens, PrintModi, voiceoptions, Versand, channelIcons, sizesSticker, sizesImg };
